module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.campaign) ? [_c('campaign-heading', {
    attrs: {
      "campaign": _vm.campaign
    }
  }), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('campaign-status')], 1), _c('div', {
    staticClass: "col-md-8 text-right"
  }, [(_vm.permissions.includes("publish")) ? [(_vm.responseWaiting && _vm.canSeeDetailedResponse) ? _c('b-alert', {
    attrs: {
      "show": "show",
      "variant": "info",
      "data-publish-result": "waiting"
    }
  }, [_vm._v("77API requested at: " + _vm._s(_vm.campaign.sat_requested_at) + " " + _vm._s(_vm.$t('pos.campaign.response-pending')))]) : (_vm.responseWaiting && !_vm.canSeeDetailedResponse) ? _c('b-alert', {
    attrs: {
      "show": "show",
      "variant": "info",
      "data-publish-result": "waiting"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.response-pending-simple')))]) : _vm._e(), (_vm.responseOK && _vm.canSeeDetailedResponse) ? _c('b-alert', {
    attrs: {
      "show": "show",
      "variant": "success",
      "data-publish-result": "success"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.published-at')) + ": " + _vm._s(_vm.campaign.sat_responded_at))]) : _vm._e(), (_vm.responseOK && !_vm.canSeeDetailedResponse) ? _c('b-alert', {
    attrs: {
      "show": "show",
      "variant": "success",
      "data-publish-result": "success"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.published-at-simple')))]) : _vm._e(), (_vm.responseKO && _vm.canSeeDetailedResponse) ? _c('b-alert', {
    attrs: {
      "show": "show",
      "variant": "danger",
      "data-publish-result": "error"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.publish-error') + ': ')), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.campaign.publish_error_response)
    }
  }, [_vm._v(_vm._s(_vm.campaign.sat_responded_at))])]) : _vm._e(), (_vm.responseKO && !_vm.canSeeDetailedResponse) ? _c('b-alert', {
    attrs: {
      "show": "show",
      "variant": "danger",
      "data-publish-result": "error"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.publish-error-simple')))]) : _vm._e(), (_vm.showFbButton) ? _c('a', {
    attrs: {
      "href": _vm.campaign.direct_link,
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.fb-link')))]) : _vm._e(), _c('gotu-nav-button', {
    staticClass: "mx-1",
    attrs: {
      "disabled": !_vm.permissions.includes("publish")
    },
    on: {
      "click": _vm.publishCampaign
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.publish')))])] : _vm._e(), (_vm.hasUnfinishedIteration) ? _c('b-alert', {
    attrs: {
      "show": "show",
      "variant": "info",
      "data-publish-result": "waiting"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.iterations.has-unfinished')))]) : _vm._e(), ((_vm.unpublishedChanges.length > 0) && _vm.canSeeDetailedResponse) ? _c('b-alert', {
    attrs: {
      "show": "show",
      "variant": "info",
      "data-publish-result": "waiting"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.unpublished-changes')) + ": " + _vm._s(_vm.unpublishedChanges.join(', ')))]) : _vm._e(), (_vm.permissions.includes("triggerStatusEnterFinNotification")) ? _c('trigger-notification', {
    attrs: {
      "kind": "campaign",
      "modelKey": _vm.campaign.code,
      "notification": _vm.NOTIFICATION_EVENTS.CAMPAIGN_STATUS_ENTER_FIN
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.trigger-status-enter-fin')))]) : _vm._e(), (_vm.permissions.includes("toggleCustomAudienceOptOut")) ? _c('gotu-nav-button', {
    staticClass: "mx-1",
    attrs: {
      "theme": "default-cta",
      "classNmae": "btn-block",
      "disabled": _vm.customAudienceOptOut
    },
    on: {
      "click": _vm.toggleCustomAudience
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.custom-audience-toggle')))]) : _vm._e()], 2)]), (_vm.disapprovalMessages) ? _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ul', {
    staticClass: "disapproval-reasons"
  }, _vm._l((_vm.disapprovalMessages), function(disapprovalMessage) {
    return _c('li', [_vm._v(_vm._s(disapprovalMessage))])
  }))])]) : _vm._e(), (_vm.statsVisible) ? _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('campaign-statistics')], 1)]) : _vm._e(), (_vm.permissions.includes("updateLeadContacts")) ? _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('lead-contact-box')], 1)]) : _vm._e(), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('landing-page-box', {
    attrs: {
      "readonly": !_vm.permissions.includes("updateLandingPage")
    }
  }), _c('start-date-box', {
    staticClass: "mt-4",
    attrs: {
      "readonly": !_vm.permissions.includes("updateStartDate") || _vm.isASAP
    }
  }), _c('campaign-info', {
    staticClass: "mt-4",
    attrs: {
      "showCreatorEdit": true,
      "showStatus": false
    }
  }), _c('customer-info', {
    staticClass: "mt-4",
    attrs: {
      "model": _vm.customer,
      "headerCustomerOpen": true
    }
  }), (_vm.permissions.includes("triggerCustomerAccessDetailsNotification")) ? _c('trigger-notification', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "wide": "wide",
      "kind": "campaign",
      "modelKey": _vm.campaign.code,
      "notification": _vm.NOTIFICATION_EVENTS.CAMPAIGN_CUSTOMER_ACCESS_DETAILS
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.trigger-customer-access-details-notification')))]) : _vm._e(), (_vm.permissions.includes("viewCreativeRefresh")) ? _c('creative-logs', {
    staticClass: "mt-4",
    attrs: {
      "items": _vm.creativeLogs
    }
  }) : _vm._e(), (_vm.canPublish) ? _c('auto-publish-box', {
    staticClass: "my-4",
    attrs: {
      "readonly": !_vm.permissions.includes("toggleAutoPublish")
    }
  }) : _vm._e(), (_vm.canSuspendResumeCampaign) ? _c('suspend-resume-box', {
    staticClass: "my-4"
  }) : _vm._e(), (_vm.canCancelCampaign) ? _c('gotu-nav-button', {
    staticClass: "mx-1",
    attrs: {
      "theme": "default-cta",
      "classNmae": "btn-block"
    },
    on: {
      "click": _vm.cancelCampaign
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.cancel-campaign')))]) : _vm._e()], 1), _c('div', {
    staticClass: "col-md-6"
  }, [_c('facebook-page-box', {
    attrs: {
      "readonly": !_vm.permissions.includes("updateFacebookPage")
    }
  }), _c('creatives', {
    staticClass: "mt-4"
  }), _c('creative-refresh', {
    staticClass: "mt-1"
  }), (_vm.permissions.includes("setSpecialAdCategory")) ? _c('special-ad-category', {
    staticClass: "mt-4"
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 mt-4"
  }, [(_vm.permissions.includes("addComment")) ? _c('comment', {
    ref: "comment",
    attrs: {
      "comment": _vm.comment
    }
  }, [_c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "disabled": _vm.addingComment,
      "loading": _vm.addingComment
    },
    on: {
      "click": _vm.updateComment
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.comment.add-comment')))])], 1)]) : _vm._e()], 1), (_vm.canViewTimeline) ? _c('div', {
    staticClass: "col-12 mt-4"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('pos.timeline.title.campaign')))]), _c('hr'), _c('timeline', {
    attrs: {
      "items": _vm.campaign.timeline
    }
  })], 1) : _vm._e()])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89c1ddcc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lab/campaign-step/CampaignStep.vue
// module id = 2079
// module chunks = 1